const state = {
  storedSpotId: null,
  checkedReports: []
}

const getters = {
  storedSpotId: (state) => {
    return state.storedSpotId
  },
  checkedReports: (state) => {
    return state.checkedReports
  }
}

const actions = {
  setStoredSpotId({ commit }, value) {
    commit('SET_STORED_SPOT_ID', value)
  },
  setcheckedReport({ commit }, next) {
    commit('SET_CHECKED_REPORT', next)
  },
  reset({ commit }, auditId) {
    commit('RESET', auditId)
  }
}

const mutations = {
  SET_STORED_SPOT_ID(state, value) {
    state.storedSpotId = value
  },
  SET_CHECKED_REPORT(state, next) {
    const report = state.checkedReports.find(
      (el) => el.auditId === next.auditId
    )
    if (!report) {
      state.checkedReports.push(next)
    } else {
      state.checkedReports.find((el) => {
        if (el.auditId === next.auditId) {
          el.auditId = next.auditId
          el.id = next.id
        }
      })
    }
  },
  RESET(state, auditId) {
    state.checkedReports = state.checkedReports.filter(
      (el) => el.auditId !== auditId
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
